import { Button, Typography, Modal } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

export default function VerificationModal({ showVerificationModal, setShowVerificationModal }) {
  return (
    <Modal
      visible={showVerificationModal}
      onCancel={() => setShowVerificationModal(false)}
      footer={[
        <Button key="cancel" onClick={() => setShowVerificationModal(false)}>
          Ok
        </Button>,
      ]}
      title={
        <>
          <Text type="warning">
            <ClockCircleOutlined className="inline mr-2" /> Verification in progress
          </Text>
        </>
      }
    >
      <Text>make sure you have entered valid mobile number, please validate once in update profile section. <br /> We will verify and let you know once verification done.</Text>
    </Modal>
  );
}